import request from '@/utils/request'
import URL from '@/api/urlTranslator'
// 查询箱货信息
export function queryContainerInfo(data) {
  return request({
    url: URL.seaExport.queryContainerInfo,
    method: 'post',
    data
  })
}

// 查询港区信息
export function queryPortInfo(params) {
  return request({
    url: URL.seaExport.queryPortInfo,
    method: 'get',
    params
  })
}

// 查询港区信息
export function getOpening(params) {
  return request({
    url: URL.seaExport.getOpening,
    method: 'get',
    params
  })
}
// 查询箱货信息
export function queryContainerList(params) {
  return request({
    url: URL.seaExport.queryContainerList,
    method: 'get',
    params
  })
}

// 查询箱货信息
export function portContainerInfo(params) {
  return request({
    url: URL.seaExport.portContainerInfo,
    method: 'get',
    params
  })
}

// 查询空运追踪信息
export function airDataTracking(params) {
  return request({
    url: URL.seaExport.airExport,
    method: 'get',
    params
  })
}

// 查询港区船期列表
export function shippingSchedules(params) {
  return request({
    url: URL.seaExport.shippingSchedules,
    method: 'get',
    params
  })
}

// 保存港区船期信息
export function shippingScheduleDistrict(params) {
  return request({
    url: URL.seaExport.shippingScheduleDistrict,
    method: 'get',
    params
  })
}

// 同步业务船期信息
export function syncScheduleDataToJobBySchedule(data) {
  return request({
    url: URL.seaExport.syncScheduleDataToJobBySchedule,
    method: 'post',
    data
  })
}
// 获取船期选择状态
export function getShippingScheduleDistrict(params) {
  return request({
    url: URL.seaExport.getShippingScheduleDistrict,
    method: 'get',
    params
  })
}
// 获取航运追踪详情
export function getAirTrackingDetails(params) {
  return request({
    url: URL.seaExport.getAirTrackingDetails,
    method: 'get',
    params
  })
}
// 获取航运信息
export function getAirFlightDetails(params) {
  return request({
    url: URL.seaExport.getAirFlightDetails,
    method: 'get',
    params
  })
}
// 获取航运信息
export function isAirDataServiceOpen(params) {
  return request({
    url: URL.seaExport.isAirDataServiceOpen,
    method: 'get',
    params
  })
}
